// extracted by mini-css-extract-plugin
module.exports = {"alt":"Image_alt__wcGAQ","imageWrapper":"Image_imageWrapper__m8qmz"};